import { Injectable } from '@angular/core';
import * as OT from '@opentok/client';

@Injectable({
  providedIn: 'root',
})
export class OpentokService {
  session: OT.Session;
  token: string;

  API_KEY = '46393622';
  SESSION_ID = '2_MX40NjM5MzYyMn5-MTU2Njk4Mzg2MTQ2M35vbk5kSzFXUEM5Nm10cjRkVmxwN0g1WVZ-fg';
  TOKEN =
    'T1==cGFydG5lcl9pZD00NjM5MzYyMiZzaWc9ZTRhYjdjYTJmNGRiNzM1ZDhlYWNkMzE4NjNkYjdjNTgxYWQyYjk3ZjpzZXNzaW9uX2lkPTJfTVg0ME5qTTVNell5TW41LU1UVTJOams0TXpnMk1UUTJNMzV2Yms1a1N6RlhVRU01Tm0xMGNqUmtWbXh3TjBnMVdWWi1mZyZjcmVhdGVfdGltZT0xNTY5NTg5OTU3Jm5vbmNlPTAuMDgwODI2ODUxNDg1NzQ5NTMmcm9sZT1wdWJsaXNoZXImZXhwaXJlX3RpbWU9MTU3MjE4MTk1NyZjb25uZWN0aW9uX2RhdGE9JTdCJTIydXNlcm5hbWUlMjIlMjAlM0ElMjAlMjJDb250YWN0JTIyJTdEJmluaXRpYWxfbGF5b3V0X2NsYXNzX2xpc3Q9';

  getOT() {
    return OT;
  }

  initSession(apiKey: string, token: string, sessionId: string) {
    if (apiKey && token && sessionId) {
      this.session = this.getOT().initSession(apiKey, sessionId);
      this.token = token;
      return Promise.resolve(this.session);
    }
    return Promise.reject();
  }

  oldInitSession() {
    if (this.API_KEY && this.TOKEN && this.SESSION_ID) {
      this.session = this.getOT().initSession(this.API_KEY, this.SESSION_ID);
      this.token = this.TOKEN;
      return Promise.resolve(this.session);
    }
    return Promise.reject();
  }

  connect() {
    return new Promise((resolve, reject) => {
      this.session.connect(this.token, err => {
        if (err) {
          reject(err);
        } else {
          resolve(this.session);
        }
      });
    });
  }
}
